export const MenuItems = [
  {
    title: "Swap",
    url: "/QL1-Testnet-Minimal/",
    cName: "nav-links",
  },
  {
    title: "Liquidity",
    url: "/QL1-Testnet-Minimal/liquidity",
    cName: "nav-links",
  },
];
